export default __webpack_public_path__ + "48090468aff7a333f9dfcf2a994ae51e.png";